<script>
import {BTd} from "bootstrap-vue";

export default {
  extends: BTd
};
</script>